<template>
  <b-form-datepicker
    id="datepicker-valid"
    v-model="selectedDateValue"
    :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
    :initial-date="initialDate"
    :min="minDate"
    :max="maxDate"
    class="width-150"
    size="sm"
    right
    @context="onDatepickerContext"
  />
</template>

<script>
import {
    BFormDatepicker,
} from 'bootstrap-vue'

import { coreApiPageFilterObject } from '@/coreApi/filters/coreApiPageFilter'
import { coreApiPageDateFilterObject } from '@/coreApi/filters/coreApiPageDateFilter'

// eslint-disable-next-line import/no-extraneous-dependencies
const moment = require('moment')

// eslint-disable-next-line no-unused-vars
const querystring = require('querystring')

export default {
    components: {
        BFormDatepicker,
    },
    props: {
        filters: {
            type: Array,
            default: () => coreApiPageFilterObject.getFilterList(),
        },
    },
    data() {
        const pageDateFilter = coreApiPageDateFilterObject.getQueryStringFilter()
        // console.log('pageDateFilter', pageDateFilter)
        let selectedDateValue = moment().format('YYYY-MM-DD')
        if (pageDateFilter && typeof pageDateFilter.datetime !== 'undefined' && pageDateFilter.datetime.length) {
            selectedDateValue = pageDateFilter.datetime[0].slice(2)
        }

        const initialDate = new Date()
        const maxDate = new Date()
        const minDate = new Date('Jan 01, 2023 00:00:00')

        return {
            initialDate,
            maxDate,
            minDate,
            selectedDateValue,
            datePickerInit: false,
        }
    },
    methods: {
        onDatepickerContext(ctx) {
            if (this.datePickerInit) {
                const filters = { datetime: [`d:${ctx.selectedYMD}`] }
                const newPath = coreApiPageDateFilterObject.getFilterUrl(filters)
                if (newPath !== this.$route.fullPath) {
                    this.$router.push(newPath)
                }
            }
            this.datePickerInit = true
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
